var _circle, _circle2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.2809,
    fill: "url(#paint0_linear_685_3216)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_685_3216)",
    strokeWidth: 0.438272
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5001,
    cy: 35.5001,
    r: 28.7068,
    fill: "url(#paint2_linear_685_3216)",
    fillOpacity: 0.5,
    stroke: "url(#paint3_linear_685_3216)",
    strokeWidth: 0.438272
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9997 23.3334L21.333 48.6667H50.6663L35.9997 23.3334Z",
    stroke: "#981B14",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43.3334V44.0001M36 32.6667L36.0053 39.3334",
    stroke: "#981B14",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_685_3216",
    x1: 35.5,
    y1: 3.28704,
    x2: 35.7772,
    y2: 104.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299E47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300199,
    stopColor: "#299E47",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#299E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_685_3216",
    x1: 35.5,
    y1: 0,
    x2: 35.5,
    y2: 87.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41464D",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_685_3216",
    x1: 35.5001,
    y1: 6.57422,
    x2: 36.6752,
    y2: 98.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E2929",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356773,
    stopColor: "#9E2929",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E2929",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_685_3216",
    x1: 35.5001,
    y1: 6.57422,
    x2: 35.5001,
    y2: 64.4261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA7CD",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.afc2304945ffa09a3034ee6cf76548ba.svg";
export { ForwardRef as ReactComponent };